import { render, staticRenderFns } from "./InventoryChicksMain.vue?vue&type=template&id=332823ba&scoped=true"
import script from "./InventoryChicksMain.vue?vue&type=script&lang=js"
export * from "./InventoryChicksMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332823ba",
  null
  
)

export default component.exports